import * as React from "react";

function SvgUserVoice(props, ref) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="1.334 1.464 299 65.629"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path
        fill="#656464"
        d="M21.494 49.375c-.179-1.49-.179-2.982-.179-4.476h-.119c-1.73 3.045-5.666 5.19-9.365 5.19-7.098 0-10.497-3.996-10.497-10.916V21.46h3.937v15.45c0 6.203 1.728 9.602 7.574 9.602.836 0 8.47-.535 8.47-10.736V21.46h3.937v21.77c0 1.492.178 4.116.298 6.145h-4.056zM46.306 28.08c-1.192-2.266-3.16-3.757-6.023-3.757-2.744 0-5.786 1.192-5.786 4.175 0 2.625 1.849 3.579 5.488 4.414l3.996.955c3.878.894 6.799 3.698 6.799 7.634 0 6.084-5.427 8.588-10.855 8.588-4.235 0-8.113-1.489-10.737-5.428l3.4-2.324c1.611 2.504 4.056 4.174 7.337 4.174 3.221 0 6.562-1.43 6.562-4.651 0-2.805-2.387-3.758-5.309-4.473l-3.817-.896c-1.909-.479-7.158-2.03-7.158-7.337 0-5.786 5.07-8.411 10.319-8.411 3.876 0 7.516 1.372 9.304 5.009l-3.52 2.328zM56.683 36.492c.479 5.604 4.712 10.02 10.26 10.02 4.175 0 7.396-2.326 8.947-4.831l3.042 2.505c-3.28 4.174-7.396 5.904-11.989 5.904-8.29 0-14.434-6.264-14.434-14.672 0-8.411 6.144-14.673 14.076-14.673 8.471.061 13.361 6.322 13.361 13.957v1.791H56.683zm18.968-3.222c0-5.309-3.4-8.947-9.067-8.947-5.129 0-9.781 4.354-9.781 8.947h18.848zM84.539 30.167c0-2.505-.119-4.652-.239-8.708h3.877v5.188h.12c1.132-2.981 4.055-5.905 8.945-5.905 1.135 0 2.09.119 2.924.358l-.776 3.877c-.477-.179-1.192-.299-2.266-.299-5.964 0-8.65 5.19-8.65 8.948v15.747h-3.935V30.167z"
      />
      <path
        fill="#F7941E"
        d="M116.807 49.375h-4.414L101.06 21.46h4.712l8.888 23.5h.119l8.886-23.5h4.472l-11.33 27.915zM142.154 50.089c-8.649 0-14.792-6.264-14.792-14.673 0-8.411 6.143-14.673 14.792-14.673 8.71 0 14.852 6.262 14.852 14.673-.001 8.41-6.141 14.673-14.852 14.673zm0-25.766c-6.442 0-10.499 4.832-10.499 11.094 0 6.263 4.057 11.094 10.499 11.094 6.502 0 10.559-4.831 10.559-11.094s-4.057-11.094-10.559-11.094zM164.523 49.375h-3.939V21.46h3.939v27.915zM189.871 28.02c-1.312-2.028-3.877-3.697-6.979-3.697-6.5-.12-10.497 4.711-10.497 11.094 0 6.383 3.997 11.213 10.497 11.094 3.103 0 5.668-1.67 6.979-3.696l3.221 2.444c-2.743 3.22-6.441 4.773-10.2 4.83-9.124.121-14.793-6.264-14.793-14.672 0-8.411 5.669-14.792 14.793-14.673 3.759.061 7.457 1.611 10.2 4.832l-3.221 2.444zM198.041 36.492c.479 5.604 4.711 10.02 10.26 10.02 4.175 0 7.396-2.326 8.947-4.831l3.041 2.505c-3.279 4.174-7.396 5.904-11.988 5.904-8.293 0-14.434-6.264-14.434-14.672 0-8.411 6.141-14.673 14.076-14.673 8.471.061 13.357 6.322 13.357 13.957v1.791h-23.259zm18.966-3.222c0-5.309-3.399-8.947-9.064-8.947-5.133 0-9.785 4.354-9.785 8.947h18.849z"
      />
      <g>
        <path
          fill="#FFF"
          d="M287.73 3.792l-.023-.005-.045-.008-.24-.038-.217.031c-.692.095-6.937 1.167-12.654 9.458-4.233 6.136-29.534 8.525-38.053 8.879l-.854.028-.429.781c-.131.238-.516.99-.949 2.082-1.904.155-3.477.924-4.57 2.265a5.903 5.903 0 00-.406.558c-1.346 2.069-1.699 5.167-.938 8.458.876 3.789 4.116 4.785 6.304 4.818.374.631.783 1.249 1.258 1.82l.012.016.436.498.582.029s5.215.231 5.389.242c.269.041 1.688.323 2.469 1.41.58.807.715 1.956.4 3.415-1.171 5.445-2.131 7.125-2.152 7.163a.972.972 0 00-.037.061l-.028.059c-.144.284-1.376 2.859-.401 5.189.367.885 1.207 2.069 3.117 2.688l.047.015 6.519 1.604.052.012 1.023-.132a6.88 6.88 0 001.938-1.564l-.146.184a11.693 11.693 0 002.09-2.406c.742-1.146 1.392-2.63 1.365-4.293-.025-1.52-.609-2.906-1.729-4.143.118-.152.242-.299.348-.463.903-1.394 1.336-3.072.508-4.644l-.279-.522c-1.102-2.051-1.395-2.933-1.061-3.448.015-.024.043-.04.06-.062.243-.035.502-.062.782-.066l.236-.008s.039-.012.071-.024c.706-.049 6.317-.108 16.411 9.172.805 1.272 4.923 7.349 10.423 7.812 2.896.246 5.593-1.059 8.009-3.877.357-.42.703-.885 1.034-1.396 2.501-3.853 4.306-10.337 5.021-18.194.793-8.681.049-17.482-1.984-23.545-1.904-5.654-4.91-9.078-8.709-9.909z"
        />
        <path
          fill="#F7941E"
          d="M272.203 41.559c-.045-.288-.076-.58-.111-.871a61.64 61.64 0 01-.317-4.574c-.108-5.005.459-9.598.688-11.215a53.776 53.776 0 011.885-7.934s-7.586 14.708-.838 31.525c0 0-.805-2.679-1.328-7.019.012.058.021.088.021.088zM289.562 7.647s-8.245-4.962-11.688 21.147c0 0-3.129 29.938 10.903 26.854 0 0-10.495 3.73-11.657-16.303-1.162-20.035 6.01-35.608 12.442-31.698z"
        />
        <path
          fill="#F7941E"
          d="M297.935 12.804c-2.691-8.026-7.018-10.532-10.164-11.22l-.725-.12-.508.071c-1.274.175-7.951 1.496-14.026 10.303-3.015 4.369-23.128 7.462-36.472 8.016l-1.994.066-.979 1.782c-.059.105-.289.536-.6 1.228-1.914.402-3.527 1.361-4.715 2.814-.189.23-.369.477-.535.733-1.65 2.542-2.092 6.186-1.209 9.997.947 4.102 4.107 5.898 7.096 6.285.279.422.555.794.818 1.109l1.097 1.264 1.438.072s4.42.195 5.248.233c.299.065.842.263 1.074.587.227.314.25.98.068 1.828-.997 4.643-1.821 6.369-1.928 6.58l-.121.219c-.305.605-1.756 3.77-.463 6.861.748 1.801 2.291 3.156 4.383 3.833L251.416 67l.401.094 1.29-.168.355-.012.397-.207a8.782 8.782 0 002.177-1.641v.002a13.676 13.676 0 002.465-2.837c1.148-1.772 1.717-3.594 1.688-5.414a7.908 7.908 0 00-1.282-4.2c1.074-2.035 1.143-4.123.174-5.955l-.283-.531c-.104-.194-.196-.373-.28-.534 2.047.407 6.562 2.028 13.479 8.344 1.394 2.144 5.731 7.995 11.795 8.507.4.034.807.047 1.201.031h.002c3.111-.107 5.971-1.657 8.496-4.604a15.2 15.2 0 001.19-1.604c2.696-4.152 4.591-10.938 5.336-19.102.815-8.938.036-18.046-2.082-24.365zm-68.371 22.849c-.715-3.108-.342-5.951 1.012-7.602.949-1.158 2.35-1.728 4.162-1.692-.32.934-.636 2.033-.857 3.239-.473 2.548-.588 5.972.884 9.253.048.104.082.211.133.316-.624.062-4.455.272-5.334-3.514zm26.023 12.203l.275.522c.071.136.121.272.16.41-.008.363-.249 1.319-2.244 2.498a3.251 3.251 0 00-.514-1.256c-.686-1.025-1.585-3.887-.559-5.859.426-.826 1.125-1.399 2.098-1.727-1.335 1.47-.216 3.554.784 5.412zm-1.216 5.123c1.23 1.002 1.938 2.119 2.123 3.334.002.151-.037 1.688-1.834 3.294-.104-.523-.328-1.054-.688-1.591-1.255-1.874-1.312-3.035-1.109-3.703l1.508-1.334zm42.304-24.509l.01.385c.006.358.009.717.01 1.077l.001.416c-.001.354-.006.708-.012 1.062-.003.143-.005.287-.009.43-.008.348-.02.694-.03 1.041l-.019.458a68.392 68.392 0 01-.078 1.488c-.021.333-.047.664-.07.995-.014.162-.025.323-.04.485a64.776 64.776 0 01-.242 2.411c-.021.169-.04.336-.062.502-.038.308-.078.613-.12.919-.022.17-.05.34-.074.51-.044.296-.089.593-.138.886-.026.172-.057.344-.084.514-.051.287-.1.572-.151.854-.032.174-.065.342-.101.512a37.717 37.717 0 01-.273 1.326 49.408 49.408 0 01-.499 2.057c-.042.16-.088.312-.132.47-.068.25-.141.5-.212.743-.046.15-.095.298-.142.447-.074.24-.148.479-.228.711-.048.146-.099.281-.147.422-.082.23-.162.464-.246.688-.051.131-.102.252-.15.378-.089.226-.178.453-.27.669-.049.111-.099.217-.146.326-.098.223-.195.443-.298.657-.042.086-.086.166-.128.25-.11.228-.223.45-.34.665-.023.044-.049.083-.072.126a15.075 15.075 0 01-.924 1.463c-.113.164-.236.31-.356.459-.062.073-.12.158-.182.229-1.231 1.435-2.522 2.398-3.861 2.908-.062.023-.12.055-.182.077-.095.032-.191.05-.287.079-.187.055-.373.115-.562.152-.029.006-.062.006-.093.013a6.438 6.438 0 01-.769.097 5.74 5.74 0 01-.869-.012c-5.158-.438-9.229-7.145-9.268-7.211l-.01-.016-.013-.012-.006-.007c-.263-.241-.519-.469-.772-.698-5.75-5.172-10.052-7.363-12.684-8.285-1.465-.508-2.57-.695-3.333-.752-.714-.057-1.13.002-1.238.021h-.01l-.001.002h-.001c-.019.001-.038.005-.058.006a7.474 7.474 0 00-1.461.173c-.275.063-.525.15-.769.248h-.001c-.911.36-1.594.941-2.016 1.758-1.094 2.104-.164 5.037.574 6.142 1.037 1.558.243 2.983.127 3.179.008-.01.021-.016.026-.02l-.039.039.013-.021c-.01.007-.031.027-.045.039l.004.001a.04.04 0 01-.014.012l.001.002c-.142.123-.437.438-.552 1.032a2.79 2.79 0 00-.031.644l-.002.002.001.02c.005.104.019.21.034.318.025.197.062.4.127.615l.002.002c.191.645.538 1.352 1.053 2.123.645.955.852 1.886.627 2.766-.025.098-.074.18-.109.271l-.006.008a3.68 3.68 0 01-.604 1.057l-.006.006.083.096-.098-.08a5.426 5.426 0 01-1.4 1.152L251 63.148l-5.205-1.279c-1.047-.343-1.748-.934-2.092-1.75-.703-1.678.346-3.801.356-3.822.11-.186 1.112-1.914 2.354-7.674.412-1.934.187-3.522-.681-4.728-.81-1.13-1.989-1.657-2.786-1.897a5.13 5.13 0 00-.857-.19l-4.652-.205-.688-.03a12.345 12.345 0 01-.986-1.384c-.027-.045-.051-.09-.078-.136-.107-.18-.214-.362-.312-.545-.062-.116-.117-.234-.174-.352-2.201-4.467-1.289-9.391-.26-12.517.062-.187.124-.367.186-.54l.074-.203c.039-.105.077-.21.115-.309l.085-.221.097-.244.086-.207c.029-.072.059-.138.086-.205.064-.151.127-.291.185-.417l.026-.062.097-.207c.011-.023.022-.047.034-.069.027-.06.055-.115.078-.165.01-.019.019-.036.025-.053l.121-.238c.86-.038 8.896-.426 17.455-1.711 4.549-.681 8.424-1.48 11.613-2.393 5.318-1.519 8.738-3.353 10.207-5.484 5.336-7.735 11.089-8.697 11.497-8.755l-.003-.001.004.001h-.001a6.64 6.64 0 011.133.363c.125.052.242.127.364.187.238.117.479.232.709.378.15.096.296.216.443.325.19.14.383.275.567.436.16.14.313.303.469.458.161.161.322.318.478.495.162.183.314.387.47.587.14.181.28.36.415.556.154.224.302.466.449.708.125.204.248.407.367.623.143.26.279.535.416.813.113.233.227.467.336.712.127.287.248.584.367.887.152.387.307.772.445 1.187l.035.098a36.853 36.853 0 011.255 4.92c.075.397.144.8.21 1.206l.023.137c.061.386.115.778.17 1.172.01.069.021.138.029.208.051.38.096.764.139 1.149l.029.26a67 67 0 01.107 1.133c.009.1.02.199.027.299.029.374.058.75.08 1.127.009.107.017.215.022.323.022.371.04.744.058 1.118.004.118.01.235.016.353.024.362.033.729.041 1.096z"
        />
        <path
          fill="#F7941E"
          d="M290.762 28.707l-.599-.225-11.951-2.656-.062.278 11.767 2.618a.817.817 0 01.474-.134c.13.005.175.292.295.366l.076-.247z"
        />
        <path
          fill="#F7941E"
          d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
        />
        <defs>
          <path
            id="UserVoice_svg__a"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__b">
          <use xlinkHref="#UserVoice_svg__a" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__b)"
          fill="#F7941E"
          d="M279.362 24.383l4.882.63-3.721-2.416z"
        />
        <defs>
          <path
            id="UserVoice_svg__c"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__d">
          <use xlinkHref="#UserVoice_svg__c" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__d)"
          fill="#F7941E"
          d="M279.251 24.557l5.351.688-.358-.232-4.882-.63z"
        />
        <defs>
          <path
            id="UserVoice_svg__e"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__f">
          <use xlinkHref="#UserVoice_svg__e" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__f)"
          fill="#F7941E"
          d="M279.139 24.728l5.819.751-.356-.234-5.351-.688z"
        />
        <defs>
          <path
            id="UserVoice_svg__g"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__h">
          <use xlinkHref="#UserVoice_svg__g" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__h)"
          fill="#F7941E"
          d="M279.028 24.899l6.288.811-.358-.231-5.819-.751z"
        />
        <defs>
          <path
            id="UserVoice_svg__i"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__j">
          <use xlinkHref="#UserVoice_svg__i" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__j)"
          fill="#F7941E"
          d="M278.914 25.072l6.759.871-.357-.233-6.288-.811z"
        />
        <defs>
          <path
            id="UserVoice_svg__k"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__l">
          <use xlinkHref="#UserVoice_svg__k" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__l)"
          fill="#F7941E"
          d="M278.802 25.244l7.235.931-.364-.232-6.759-.871z"
        />
        <defs>
          <path
            id="UserVoice_svg__m"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__n">
          <use xlinkHref="#UserVoice_svg__m" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__n)"
          fill="#F7941E"
          d="M278.693 25.417l7.698.99-.354-.232-7.235-.931z"
        />
        <defs>
          <path
            id="UserVoice_svg__o"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__p">
          <use xlinkHref="#UserVoice_svg__o" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__p)"
          fill="#F7941E"
          d="M278.582 25.587l8.168 1.054-.359-.234-7.698-.99z"
        />
        <defs>
          <path
            id="UserVoice_svg__q"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__r">
          <use xlinkHref="#UserVoice_svg__q" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__r)"
          fill="#F7941E"
          d="M278.468 25.76l8.638 1.112-.356-.231-8.168-1.054z"
        />
        <defs>
          <path
            id="UserVoice_svg__s"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__t">
          <use xlinkHref="#UserVoice_svg__s" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__t)"
          fill="#F7941E"
          d="M278.355 25.932l9.109 1.173-.358-.233-8.638-1.112z"
        />
        <defs>
          <path
            id="UserVoice_svg__u"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__v">
          <use xlinkHref="#UserVoice_svg__u" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__v)"
          fill="#F7941E"
          d="M278.246 26.104l9.576 1.234-.358-.233-9.109-1.173z"
        />
        <defs>
          <path
            id="UserVoice_svg__w"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__x">
          <use xlinkHref="#UserVoice_svg__w" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__x)"
          fill="#F7941E"
          d="M278.134 26.276l10.048 1.294-.36-.232-9.576-1.234z"
        />
        <defs>
          <path
            id="UserVoice_svg__y"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__z">
          <use xlinkHref="#UserVoice_svg__y" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__z)"
          fill="#F7941E"
          d="M278.023 26.449l10.516 1.353-.357-.232-10.048-1.294z"
        />
        <defs>
          <path
            id="UserVoice_svg__A"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__B">
          <use xlinkHref="#UserVoice_svg__A" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__B)"
          fill="#F7941E"
          d="M277.91 26.621l10.988 1.414-.359-.233-10.516-1.353z"
        />
        <defs>
          <path
            id="UserVoice_svg__C"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__D">
          <use xlinkHref="#UserVoice_svg__C" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__D)"
          fill="#F7941E"
          d="M277.798 26.792l11.457 1.476-.357-.233-10.988-1.414z"
        />
        <defs>
          <path
            id="UserVoice_svg__E"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__F">
          <use xlinkHref="#UserVoice_svg__E" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__F)"
          fill="#F7941E"
          d="M277.686 26.965l11.929 1.535-.36-.232-11.457-1.476z"
        />
        <defs>
          <path
            id="UserVoice_svg__G"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__H">
          <use xlinkHref="#UserVoice_svg__G" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__H)"
          fill="#F7941E"
          d="M277.576 27.136l12.398 1.598-.359-.234-11.929-1.535z"
        />
        <defs>
          <path
            id="UserVoice_svg__I"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__J">
          <use xlinkHref="#UserVoice_svg__I" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__J)"
          fill="#F7941E"
          d="M277.464 27.308l12.866 1.657-.356-.231-12.398-1.598z"
        />
        <defs>
          <path
            id="UserVoice_svg__K"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__L">
          <use xlinkHref="#UserVoice_svg__K" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__L)"
          fill="#F7941E"
          d="M277.352 27.48l13.337 1.718-.359-.233-12.866-1.657z"
        />
        <defs>
          <path
            id="UserVoice_svg__M"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__N">
          <use xlinkHref="#UserVoice_svg__M" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__N)"
          fill="#F7941E"
          d="M277.24 27.652l13.804 1.778-.355-.232-13.337-1.718z"
        />
        <defs>
          <path
            id="UserVoice_svg__O"
            d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
          />
        </defs>
        <clipPath id="UserVoice_svg__P">
          <use xlinkHref="#UserVoice_svg__O" overflow="visible" />
        </clipPath>
        <path
          clipPath="url(#UserVoice_svg__P)"
          fill="#F7941E"
          d="M277.212 27.696l-.016.137 14.075 1.813.009-.064-.236-.152-13.804-1.778z"
        />
        <defs>
          <path
            id="UserVoice_svg__Q"
            d="M295.907 36.763l-2.021-12.022c-.667.634-2.553.848-4.735.465-1.961-.345-3.646-1.1-4.193-1.877a1.119 1.119 0 01-.114-.205l-3.957 10.91-.166.334c4.443 1.308 9.583 2.278 15.184 2.438l.002-.043z"
          />
        </defs>
        <clipPath id="UserVoice_svg__R">
          <use xlinkHref="#UserVoice_svg__Q" overflow="visible" />
        </clipPath>
        <path
          transform="scale(-1) rotate(-82.669 -32.772 323.145)"
          clipPath="url(#UserVoice_svg__R)"
          fill="#F7941E"
          d="M284.131 21.725h.184v14.192h-.184z"
        />
        <defs>
          <path
            id="UserVoice_svg__S"
            d="M295.627 37.015l-1.902-12.042c-.673.628-2.562.823-4.74.418-1.958-.364-3.635-1.135-4.175-1.918a1.11 1.11 0 01-.112-.206l-4.063 10.871-.168.332c4.43 1.352 9.559 2.371 15.157 2.587l.003-.042z"
          />
        </defs>
        <clipPath id="UserVoice_svg__T">
          <use xlinkHref="#UserVoice_svg__S" overflow="visible" />
        </clipPath>
        <path
          transform="rotate(97.897 284.198 28.997)"
          clipPath="url(#UserVoice_svg__T)"
          fill="#F7941E"
          d="M284.108 21.909h.185v14.194h-.185z"
        />
        <defs>
          <path
            id="UserVoice_svg__U"
            d="M295.433 37.168l-1.898-12.042c-.674.627-2.561.822-4.74.417-1.957-.365-3.634-1.137-4.174-1.919a1.144 1.144 0 01-.112-.207l-4.067 10.869-.168.332c4.428 1.354 9.558 2.375 15.156 2.593l.003-.043z"
          />
        </defs>
        <clipPath id="UserVoice_svg__V">
          <use xlinkHref="#UserVoice_svg__U" overflow="visible" />
        </clipPath>
        <path
          transform="rotate(97.897 284.184 29.195)"
          clipPath="url(#UserVoice_svg__V)"
          fill="#F7941E"
          d="M284.095 22.107h.185v14.195h-.185z"
        />
        <defs>
          <path
            id="UserVoice_svg__W"
            d="M295.38 37.041l-2.158-11.999c-.66.642-2.543.877-4.73.519-1.965-.323-3.658-1.058-4.214-1.829a1.164 1.164 0 01-.117-.204l-3.831 10.955-.162.336c4.458 1.257 9.608 2.167 15.21 2.264l.002-.042z"
          />
        </defs>
        <clipPath id="UserVoice_svg__X">
          <use xlinkHref="#UserVoice_svg__W" overflow="visible" />
        </clipPath>
        <path
          transform="scale(-1) rotate(-83.327 -33.009 319.336)"
          clipPath="url(#UserVoice_svg__X)"
          fill="#F7941E"
          d="M284.051 22.271h.185v14.193h-.185z"
        />
        <defs>
          <path
            id="UserVoice_svg__Y"
            d="M295.065 37.382l-1.96-12.032c-.671.631-2.557.835-4.738.441-1.959-.355-3.641-1.118-4.184-1.898a1.18 1.18 0 01-.113-.206l-4.012 10.89-.166.333c4.436 1.33 9.57 2.325 15.17 2.514l.003-.042z"
          />
        </defs>
        <clipPath id="UserVoice_svg__Z">
          <use xlinkHref="#UserVoice_svg__Y" overflow="visible" />
        </clipPath>
        <path
          transform="rotate(97.296 284.132 29.567)"
          clipPath="url(#UserVoice_svg__Z)"
          fill="#F7941E"
          d="M284.043 22.477h.185V36.67h-.185z"
        />
        <defs>
          <path
            id="UserVoice_svg__aa"
            d="M294.933 37.398l-2.096-12.009c-.662.638-2.547.864-4.732.495-1.963-.333-3.652-1.078-4.204-1.851a1.162 1.162 0 01-.116-.205l-3.889 10.934-.162.335c4.449 1.28 9.596 2.217 15.195 2.344l.004-.043z"
          />
        </defs>
        <clipPath id="UserVoice_svg__ab">
          <use xlinkHref="#UserVoice_svg__aa" overflow="visible" />
        </clipPath>
        <path
          transform="scale(-1) rotate(-82.726 -33.804 322.68)"
          clipPath="url(#UserVoice_svg__ab)"
          fill="#F7941E"
          d="M284.003 22.663h.185v14.19h-.185z"
        />
        <defs>
          <path
            id="UserVoice_svg__ac"
            d="M294.531 37.824l-1.762-12.062c-.681.62-2.57.793-4.744.363-1.953-.387-3.621-1.178-4.152-1.966a1.168 1.168 0 01-.11-.208l-4.189 10.823-.172.33c4.413 1.403 9.53 2.482 15.126 2.764l.003-.044z"
          />
        </defs>
        <clipPath id="UserVoice_svg__ad">
          <use xlinkHref="#UserVoice_svg__ac" overflow="visible" />
        </clipPath>
        <path
          transform="rotate(98.54 284.086 29.93)"
          clipPath="url(#UserVoice_svg__ad)"
          fill="#F7941E"
          d="M283.996 22.838h.184v14.195h-.184z"
        />
        <defs>
          <path
            id="UserVoice_svg__ae"
            d="M294.605 37.56l-2.217-11.987c-.656.645-2.538.89-4.727.542-1.967-.313-3.664-1.04-4.224-1.808a1.203 1.203 0 01-.118-.203l-3.777 10.973-.16.336c4.464 1.234 9.619 2.119 15.221 2.189l.002-.042z"
          />
        </defs>
        <clipPath id="UserVoice_svg__af">
          <use xlinkHref="#UserVoice_svg__ae" overflow="visible" />
        </clipPath>
        <path
          transform="rotate(96.056 284.054 30.118)"
          clipPath="url(#UserVoice_svg__af)"
          fill="#F7941E"
          d="M283.958 23.022h.185v14.193h-.185z"
        />
        <g>
          <defs>
            <path
              id="UserVoice_svg__ag"
              d="M294.259 37.916l-1.97-12.031c-.669.631-2.556.837-4.737.445-1.959-.354-3.641-1.115-4.186-1.895a1.18 1.18 0 01-.113-.206l-4.004 10.893-.166.333c4.438 1.328 9.572 2.318 15.172 2.503l.004-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__ah">
            <use xlinkHref="#UserVoice_svg__ag" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.556 284.038 30.298)"
            clipPath="url(#UserVoice_svg__ah)"
            fill="#F7941E"
            d="M283.945 23.207h.186v14.194h-.186z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ai"
              d="M294.083 37.992l-2.021-12.022c-.667.634-2.553.848-4.735.465-1.962-.346-3.646-1.1-4.193-1.877a1.076 1.076 0 01-.115-.206l-3.957 10.911-.165.333c4.442 1.308 9.583 2.277 15.183 2.438l.003-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aj">
            <use xlinkHref="#UserVoice_svg__ai" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.687 -34.631 322.778)"
            clipPath="url(#UserVoice_svg__aj)"
            fill="#F7941E"
            d="M283.918 23.374h.184v14.195h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ak"
              d="M293.874 38.144l-2.028-12.02c-.666.635-2.552.85-4.734.468-1.962-.344-3.646-1.098-4.195-1.874a1.252 1.252 0 01-.114-.205l-3.949 10.912-.165.333c4.443 1.305 9.584 2.271 15.184 2.428l.001-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__al">
            <use xlinkHref="#UserVoice_svg__ak" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.726 -34.848 322.544)"
            clipPath="url(#UserVoice_svg__al)"
            fill="#F7941E"
            d="M283.883 23.581h.185v14.194h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__am"
              d="M293.732 38.21l-2.086-12.01c-.664.638-2.549.862-4.734.491-1.963-.334-3.651-1.08-4.203-1.854a1.162 1.162 0 01-.116-.205l-3.896 10.933-.163.334c4.45 1.284 9.596 2.224 15.196 2.354l.002-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__an">
            <use xlinkHref="#UserVoice_svg__am" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.013 283.975 30.832)"
            clipPath="url(#UserVoice_svg__an)"
            fill="#F7941E"
            d="M283.883 23.742h.184v14.193h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ao"
              d="M293.393 38.505l-1.907-12.04c-.673.628-2.561.824-4.739.42-1.958-.364-3.636-1.134-4.175-1.916a1.152 1.152 0 01-.113-.207L278.4 35.635l-.168.332c4.43 1.351 9.559 2.367 15.157 2.581l.004-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__ap">
            <use xlinkHref="#UserVoice_svg__ao" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.166 -35.594 325.65)"
            clipPath="url(#UserVoice_svg__ap)"
            fill="#F7941E"
            d="M283.833 23.939h.186v14.193h-.186z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aq"
              d="M293.273 38.538l-2.02-12.022c-.668.634-2.553.848-4.736.465-1.961-.345-3.646-1.1-4.193-1.877a1.26 1.26 0 01-.115-.205l-3.957 10.91-.164.334c4.443 1.309 9.582 2.277 15.183 2.438l.002-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__ar">
            <use xlinkHref="#UserVoice_svg__aq" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.669 -35.482 322.795)"
            clipPath="url(#UserVoice_svg__ar)"
            fill="#F7941E"
            d="M283.824 24.108h.184v14.194h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__as"
              d="M293.136 38.572l-2.146-12.001c-.661.641-2.545.875-4.731.515-1.964-.325-3.657-1.062-4.213-1.833a1.164 1.164 0 01-.117-.204l-3.841 10.952-.162.335c4.457 1.261 9.606 2.176 15.208 2.278l.002-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__at">
            <use xlinkHref="#UserVoice_svg__as" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.293 -35.295 319.21)"
            clipPath="url(#UserVoice_svg__at)"
            fill="#F7941E"
            d="M283.787 24.286h.184v14.192h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__au"
              d="M292.831 38.854l-1.966-12.031c-.67.631-2.557.836-4.738.443-1.959-.354-3.641-1.117-4.184-1.896a1.125 1.125 0 01-.114-.206l-4.007 10.893-.166.333c4.437 1.328 9.572 2.32 15.172 2.507l.003-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__av">
            <use xlinkHref="#UserVoice_svg__au" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.126 -36.239 325.813)"
            clipPath="url(#UserVoice_svg__av)"
            fill="#F7941E"
            d="M283.77 24.477h.185v14.192h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aw"
              d="M292.666 38.935l-2.041-12.019c-.666.635-2.551.852-4.734.473-1.961-.342-3.647-1.094-4.196-1.87a1.19 1.19 0 01-.115-.205l-3.938 10.917-.164.334c4.445 1.301 9.586 2.26 15.187 2.412l.001-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__ax">
            <use xlinkHref="#UserVoice_svg__aw" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.198 283.836 31.757)"
            clipPath="url(#UserVoice_svg__ax)"
            fill="#F7941E"
            d="M283.738 24.659h.187v14.193h-.187z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ay"
              d="M292.384 39.178l-1.895-12.042c-.674.627-2.561.821-4.74.415-1.957-.366-3.634-1.138-4.174-1.921a1.136 1.136 0 01-.111-.207l-4.072 10.868-.168.332c4.429 1.354 9.558 2.378 15.156 2.598l.004-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__az">
            <use xlinkHref="#UserVoice_svg__ay" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.085 -36.69 325.998)"
            clipPath="url(#UserVoice_svg__az)"
            fill="#F7941E"
            d="M283.726 24.843h.184v14.196h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aA"
              d="M292.325 39.125l-2.147-12c-.66.642-2.543.875-4.73.515-1.965-.325-3.657-1.062-4.213-1.833a1.137 1.137 0 01-.117-.204l-3.842 10.952-.161.335c4.456 1.262 9.606 2.176 15.208 2.278l.002-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aB">
            <use xlinkHref="#UserVoice_svg__aA" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.293 -36.12 319.107)"
            clipPath="url(#UserVoice_svg__aB)"
            fill="#F7941E"
            d="M283.694 25.019h.184v14.194h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aC"
              d="M291.99 39.44l-1.902-12.042c-.673.628-2.561.823-4.74.419-1.957-.365-3.635-1.136-4.174-1.918a1.152 1.152 0 01-.113-.207l-4.064 10.871-.168.332c4.43 1.352 9.561 2.371 15.158 2.587l.003-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aD">
            <use xlinkHref="#UserVoice_svg__aC" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.897 283.77 32.297)"
            clipPath="url(#UserVoice_svg__aD)"
            fill="#F7941E"
            d="M283.681 25.211h.185v14.192h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aE"
              d="M291.892 39.462l-2.096-12.009c-.663.638-2.547.864-4.732.494-1.963-.333-3.652-1.077-4.205-1.851a1.154 1.154 0 01-.115-.205l-3.889 10.934-.163.335c4.45 1.28 9.596 2.217 15.196 2.344l.004-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aF">
            <use xlinkHref="#UserVoice_svg__aE" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.726 -36.927 322.279)"
            clipPath="url(#UserVoice_svg__aF)"
            fill="#F7941E"
            d="M283.649 25.412h.185v14.19h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aG"
              d="M291.593 39.73l-1.896-12.042c-.674.627-2.562.822-4.74.417-1.958-.365-3.635-1.137-4.174-1.92a1.18 1.18 0 01-.113-.206l-4.068 10.869-.168.332c4.43 1.354 9.559 2.375 15.156 2.594l.003-.044z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aH">
            <use xlinkHref="#UserVoice_svg__aG" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.897 283.734 32.68)"
            clipPath="url(#UserVoice_svg__aH)"
            fill="#F7941E"
            d="M283.645 25.592h.185v14.194h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aI"
              d="M291.451 39.767l-2.02-12.022c-.668.634-2.553.848-4.736.465-1.961-.346-3.646-1.1-4.193-1.877a1.268 1.268 0 01-.115-.206l-3.957 10.911-.164.333c4.442 1.308 9.582 2.277 15.182 2.438l.003-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aJ">
            <use xlinkHref="#UserVoice_svg__aI" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.669 -37.358 322.552)"
            clipPath="url(#UserVoice_svg__aJ)"
            fill="#F7941E"
            d="M283.61 25.756h.184v14.196h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aK"
              d="M291.241 39.921L289.213 27.9c-.666.635-2.552.85-4.735.468-1.961-.344-3.646-1.097-4.194-1.874a1.22 1.22 0 01-.115-.205l-3.949 10.913-.164.334c4.443 1.305 9.583 2.27 15.184 2.428l.001-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aL">
            <use xlinkHref="#UserVoice_svg__aK" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-82.726 -37.555 322.195)"
            clipPath="url(#UserVoice_svg__aL)"
            fill="#F7941E"
            d="M283.575 25.964h.185v14.194h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aM"
              d="M291.117 39.951l-2.158-11.998c-.66.642-2.543.877-4.73.519-1.965-.323-3.658-1.058-4.215-1.829a1.23 1.23 0 01-.117-.204l-3.831 10.955-.161.336c4.457 1.258 9.608 2.168 15.21 2.264l.002-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aN">
            <use xlinkHref="#UserVoice_svg__aM" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.327 -37.337 318.78)"
            clipPath="url(#UserVoice_svg__aN)"
            fill="#F7941E"
            d="M283.556 26.123h.185v14.191h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aO"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aP">
            <use xlinkHref="#UserVoice_svg__aO" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__aP)"
            fill="#F7941E"
            d="M276.605 32.417l-.027.182 14.08 1.814.021-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aQ"
              d="M290.71 40.228l-2.158-11.999c-.66.642-2.543.877-4.73.52-1.965-.323-3.658-1.058-4.214-1.829a1.201 1.201 0 01-.117-.204l-3.831 10.956-.162.335c4.458 1.257 9.608 2.167 15.21 2.265l.002-.044z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aR">
            <use xlinkHref="#UserVoice_svg__aQ" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.345 -37.735 318.606)"
            clipPath="url(#UserVoice_svg__aR)"
            fill="#F7941E"
            d="M283.507 26.489h.185v14.192h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aS"
              d="M290.443 40.452l-2.032-12.02c-.667.635-2.552.851-4.735.47-1.961-.343-3.646-1.096-4.195-1.873a1.303 1.303 0 01-.115-.206l-3.945 10.915-.164.334c4.443 1.303 9.584 2.268 15.184 2.423l.002-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aT">
            <use xlinkHref="#UserVoice_svg__aS" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.24 283.584 33.772)"
            clipPath="url(#UserVoice_svg__aT)"
            fill="#F7941E"
            d="M283.49 26.683h.186v14.194h-.186z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aU"
              d="M290.201 40.62l-1.965-12.031c-.67.631-2.557.836-4.738.444-1.959-.354-3.641-1.117-4.185-1.896a1.125 1.125 0 01-.114-.206l-4.006 10.892-.166.334c4.436 1.328 9.571 2.32 15.17 2.507l.004-.044z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aV">
            <use xlinkHref="#UserVoice_svg__aU" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.897 283.552 33.948)"
            clipPath="url(#UserVoice_svg__aV)"
            fill="#F7941E"
            d="M283.463 26.86h.185v14.194h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aW"
              d="M290.072 40.705l-2.083-12.011c-.663.638-2.548.861-4.733.49-1.963-.335-3.65-1.081-4.203-1.855a1.22 1.22 0 01-.115-.205l-3.9 10.93-.162.335c4.449 1.284 9.594 2.228 15.193 2.358l.003-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aX">
            <use xlinkHref="#UserVoice_svg__aW" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.013 283.54 34.148)"
            clipPath="url(#UserVoice_svg__aX)"
            fill="#F7941E"
            d="M283.448 27.059h.184v14.19h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__aY"
              d="M289.769 40.923l-1.902-12.042c-.674.628-2.561.823-4.74.418-1.957-.364-3.635-1.135-4.175-1.918a1.171 1.171 0 01-.112-.206l-4.064 10.871-.168.332c4.43 1.352 9.56 2.371 15.158 2.587l.003-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__aZ">
            <use xlinkHref="#UserVoice_svg__aY" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.897 283.512 34.313)"
            clipPath="url(#UserVoice_svg__aZ)"
            fill="#F7941E"
            d="M283.423 27.226h.185V41.42h-.185z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ba"
              d="M289.66 40.97l-2.079-12.012c-.664.637-2.548.86-4.733.488-1.963-.336-3.65-1.082-4.203-1.856a1.22 1.22 0 01-.115-.205l-3.902 10.93-.164.334c4.449 1.286 9.594 2.23 15.194 2.363l.002-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bb">
            <use xlinkHref="#UserVoice_svg__ba" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.293 -38.812 318.773)"
            clipPath="url(#UserVoice_svg__bb)"
            fill="#F7941E"
            d="M283.398 27.412h.184v14.195h-.184z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bc"
              d="M289.431 41.134l-2.032-12.02c-.667.635-2.552.851-4.735.47-1.961-.343-3.646-1.096-4.195-1.873a1.228 1.228 0 01-.115-.206l-3.945 10.915-.164.333c4.443 1.304 9.584 2.269 15.184 2.423l.002-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bd">
            <use xlinkHref="#UserVoice_svg__bc" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.24 283.466 34.688)"
            clipPath="url(#UserVoice_svg__bd)"
            fill="#F7941E"
            d="M283.372 27.598h.186v14.195h-.186z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__be"
              d="M289.23 41.271l-2.031-12.02c-.667.635-2.553.851-4.735.47-1.962-.343-3.647-1.096-4.195-1.873a1.16 1.16 0 01-.115-.206l-3.946 10.914-.164.334c4.443 1.305 9.584 2.268 15.185 2.424l.001-.043z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bf">
            <use xlinkHref="#UserVoice_svg__be" overflow="visible" />
          </clipPath>
          <path
            transform="rotate(97.24 283.443 34.87)"
            clipPath="url(#UserVoice_svg__bf)"
            fill="#F7941E"
            d="M283.349 27.781h.186v14.194h-.186z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bg"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bh">
            <use xlinkHref="#UserVoice_svg__bg" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bh)"
            fill="#F7941E"
            d="M276.391 34.067l-.022.182 14.074 1.816.025-.188z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bi"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bj">
            <use xlinkHref="#UserVoice_svg__bi" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bj)"
            fill="#F7941E"
            d="M276.369 34.249l-.03.185 14.08 1.814.024-.183z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bk"
              d="M288.71 41.613l-2.207-11.989c-.657.645-2.539.887-4.728.538-1.966-.315-3.662-1.043-4.222-1.812a1.111 1.111 0 01-.118-.204l-3.787 10.97-.159.336c4.462 1.239 9.615 2.129 15.217 2.203l.004-.042z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bl">
            <use xlinkHref="#UserVoice_svg__bk" overflow="visible" />
          </clipPath>
          <path
            transform="scale(-1) rotate(-83.864 -39.454 315.462)"
            clipPath="url(#UserVoice_svg__bl)"
            fill="#F7941E"
            d="M283.279 28.341h.183v14.195h-.183z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bm"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bn">
            <use xlinkHref="#UserVoice_svg__bm" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bn)"
            fill="#F7941E"
            d="M276.32 34.616l-.024.185 14.039 1.808.047-.072.015-.106z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bo"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bp">
            <use xlinkHref="#UserVoice_svg__bo" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bp)"
            fill="#F7941E"
            d="M276.296 34.801l-.024.182 13.954 1.796.109-.17z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bq"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__br">
            <use xlinkHref="#UserVoice_svg__bq" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__br)"
            fill="#F7941E"
            d="M276.272 34.983l-.022.184 13.863 1.788.113-.176z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bs"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bt">
            <use xlinkHref="#UserVoice_svg__bs" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bt)"
            fill="#F7941E"
            d="M276.25 35.167l-.027.184 13.778 1.774.112-.17z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bu"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bv">
            <use xlinkHref="#UserVoice_svg__bu" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bv)"
            fill="#F7941E"
            d="M276.223 35.351l-.02.183 13.687 1.762.111-.171z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bw"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bx">
            <use xlinkHref="#UserVoice_svg__bw" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bx)"
            fill="#F7941E"
            d="M276.203 35.534l-.026.181 13.6 1.753.113-.172z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__by"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bz">
            <use xlinkHref="#UserVoice_svg__by" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bz)"
            fill="#F7941E"
            d="M276.177 35.715l-.023.186 13.513 1.74.11-.173z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bA"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bB">
            <use xlinkHref="#UserVoice_svg__bA" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bB)"
            fill="#F7941E"
            d="M276.154 35.901l-.024.182 13.425 1.729.112-.171z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bC"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bD">
            <use xlinkHref="#UserVoice_svg__bC" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bD)"
            fill="#F7941E"
            d="M276.13 36.083l-.024.183 13.337 1.716.112-.17z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bE"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bF">
            <use xlinkHref="#UserVoice_svg__bE" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bF)"
            fill="#F7941E"
            d="M276.106 36.266l-.023.185 13.247 1.707.113-.176z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bG"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bH">
            <use xlinkHref="#UserVoice_svg__bG" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bH)"
            fill="#F7941E"
            d="M276.083 36.451l-.023.181 13.158 1.698.112-.172z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bI"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bJ">
            <use xlinkHref="#UserVoice_svg__bI" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bJ)"
            fill="#F7941E"
            d="M276.06 36.632l-.023.185 13.072 1.684.109-.171z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bK"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bL">
            <use xlinkHref="#UserVoice_svg__bK" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bL)"
            fill="#F7941E"
            d="M276.037 36.817l-.023.183 12.982 1.669.113-.168z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bM"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bN">
            <use xlinkHref="#UserVoice_svg__bM" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bN)"
            fill="#F7941E"
            d="M276.014 37l-.026.183 12.896 1.66.112-.174z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bO"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bP">
            <use xlinkHref="#UserVoice_svg__bO" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bP)"
            fill="#F7941E"
            d="M275.988 37.183l-.022.184 12.805 1.649.113-.173z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bQ"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bR">
            <use xlinkHref="#UserVoice_svg__bQ" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bR)"
            fill="#F7941E"
            d="M275.966 37.367l-.023.183 12.717 1.637.111-.171z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bS"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bT">
            <use xlinkHref="#UserVoice_svg__bS" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bT)"
            fill="#F7941E"
            d="M275.943 37.55l-.024.183 12.631 1.628.11-.174z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bU"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bV">
            <use xlinkHref="#UserVoice_svg__bU" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bV)"
            fill="#F7941E"
            d="M275.919 37.733l-.024.184 12.542 1.616.113-.172z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bW"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bX">
            <use xlinkHref="#UserVoice_svg__bW" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bX)"
            fill="#F7941E"
            d="M275.895 37.917l-.024.182 12.455 1.608.111-.174z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__bY"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__bZ">
            <use xlinkHref="#UserVoice_svg__bY" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__bZ)"
            fill="#F7941E"
            d="M275.871 38.099l-.024.184 12.365 1.592.114-.168z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ca"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cb">
            <use xlinkHref="#UserVoice_svg__ca" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cb)"
            fill="#F7941E"
            d="M275.847 38.283l-.021.183 12.276 1.582.11-.173z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__cc"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cd">
            <use xlinkHref="#UserVoice_svg__cc" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cd)"
            fill="#F7941E"
            d="M275.826 38.466l-.026.181 12.192 1.574.11-.173z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ce"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cf">
            <use xlinkHref="#UserVoice_svg__ce" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cf)"
            fill="#F7941E"
            d="M275.8 38.647l-.021.186 12.099 1.56.114-.172z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__cg"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__ch">
            <use xlinkHref="#UserVoice_svg__cg" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__ch)"
            fill="#F7941E"
            d="M275.779 38.833l-.028.183 12.016 1.547.111-.17z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ci"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cj">
            <use xlinkHref="#UserVoice_svg__ci" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cj)"
            fill="#F7941E"
            d="M275.751 39.016l-.022.183 11.925 1.537.113-.173z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__ck"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cl">
            <use xlinkHref="#UserVoice_svg__ck" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cl)"
            fill="#F7941E"
            d="M275.729 39.199l-.022.185 11.837 1.526.11-.174z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__cm"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cn">
            <use xlinkHref="#UserVoice_svg__cm" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cn)"
            fill="#F7941E"
            d="M275.707 39.384l-.025.183 11.751 1.515.111-.172z"
          />
        </g>
        <g>
          <defs>
            <path
              id="UserVoice_svg__co"
              d="M277.832 41.43l11.666-3.534c-.713-.581-1.166-2.424-1.063-4.638.093-1.989.627-3.756 1.328-4.398.063-.056.127-.104.188-.14l-11.324-2.536-.353-.121c-.731 4.573-1.039 9.794-.485 15.369l.043-.002z"
            />
          </defs>
          <clipPath id="UserVoice_svg__cp">
            <use xlinkHref="#UserVoice_svg__co" overflow="visible" />
          </clipPath>
          <path
            clipPath="url(#UserVoice_svg__cp)"
            fill="#F7941E"
            d="M275.682 39.567l-.059.461 8.787 5.707 3.023-4.653z"
          />
        </g>
        <g>
          <path
            fill="#F7941E"
            d="M289.949 29.066c-.652.592-1.152 2.283-1.238 4.208-.111 2.439.441 4.179 1.08 4.492a.604.604 0 00.188.047c.146.008.298-.06.448-.194.65-.597 1.148-2.287 1.234-4.209.092-1.921-.25-3.65-.841-4.303-.118-.129-.239-.209-.364-.232-.021-.001-.041-.005-.062-.006-.144-.008-.295.057-.445.197z"
          />
        </g>
        <g>
          <path
            fill="#F7941E"
            d="M290.839 29.019s-.467-.236-1.364-.42l.293-.209s.817.054 1.253.532l-.182.097z"
          />
        </g>
        <g>
          <path
            fill="#F7941E"
            d="M288.585 36.527l.961 1.637.554-.076c0-.003-1.145-1.176-1.515-1.561z"
          />
        </g>
        <g>
          <path
            fill="#F7941E"
            d="M289.761 28.86c-.701.642-1.235 2.409-1.328 4.398-.102 2.214.352 4.057 1.064 4.638l.276-.085.017-.045c-.64-.313-1.192-2.053-1.082-4.492.086-1.925.588-3.616 1.238-4.208.151-.14.303-.205.446-.2.021.001.042.005.062.006l.008-.04-.514-.113c-.06.037-.122.085-.187.141z"
          />
        </g>
        <g>
          <path
            fill="#F7941E"
            d="M277.757 41.716l12.097-3.641-.002-.004a.814.814 0 01-.356-.18l-11.813 3.555.074.27z"
          />
        </g>
        <path
          fill="#F7941E"
          d="M289.351 28.917l-11.078-2.568-.486 3.18 9.865 2.348s.202 3.513.799 5.028c0 0-.868-4.399.9-7.988z"
        />
      </g>
      <path
        fill="none"
        d="M254.619 53.77c.057.004.385.039.766.078-.307.286-.463.43-.797.743.013-.41.029-.767.031-.821z"
      />
    </svg>
  );
}

export default React.forwardRef(SvgUserVoice);
